import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animated-logo',
  templateUrl: './animated-logo.component.html',
  styleUrls: ['./animated-logo.component.scss']
})
export class AnimatedLogoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
